function equalizeCardHeights() {
  const cards = document.querySelectorAll('.land__splide .card-land');
  if (!cards.length) return;

  cards.forEach(card => {
    card.style.minHeight = '';
  });

  if (window.innerWidth > 960) return;

  let maxHeight = 0;
  cards.forEach(card => {
    const height = card.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  cards.forEach(card => {
    card.style.minHeight = `${maxHeight}px`;
  });
}

let resizeTimeout;
function debounceEqualize() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(equalizeCardHeights, 500);
}

window.addEventListener('load', debounceEqualize);
window.addEventListener('resize', debounceEqualize);
